import React from "react";

const statusStyles = {
  pending: {
    color: "#3047EC",
    icon: "/search-normal-blue.svg",
  },
  approved: {
    color: "#46DA55",
    icon: "/green-tick.svg",
  },
  rejected: {
    color: "#FF5050",
    icon: "/reject-red.svg",
  },
};

const StatusButton = ({ status = "", count = 0, openSection }) => {
  const normalizedStatus = status?.toLowerCase() || "pending";
  const { color, icon } =
    statusStyles[normalizedStatus] || statusStyles.pending;
  const statusLabels = {
    in_review: "In Review",
    approved: "Completed",
  };

  return (
    <div className="relative group inline-block">
      {/* Tooltip */}
      <div
        className="
          absolute -top-8 left-1/2 -translate-x-1/2
          whitespace-nowrap
          bg-blue-600 text-white text-xs px-2 py-1 rounded-md
          opacity-0 group-hover:opacity-100
          pointer-events-none
          transition-all duration-200
          shadow-md
        "
      >
        Click to see details
      </div>

      {/* Button */}
      <button
        onClick={openSection}
        className="flex text-xs bg-opacity-20 font-medium items-center border py-1 lg:px-2 px-1 rounded transition duration-200 hover:opacity-80"
        style={{
          color,
          borderColor: color,
          backgroundColor: `${color}20`,
        }}
      >
        <img
          src={icon}
          alt={`${status} icon`}
          className="h-2 w-2 md:h-3 md:w-3 md:mr-1"
        />
        <span className="hidden font-semibold lg:inline">
          {statusLabels[status] ||
            (status ? status[0].toUpperCase() + status.slice(1) : "Unknown")}
        </span>
        <span className="hidden font-semibold lg:inline px-2">({count})</span>
      </button>
    </div>
  );
};

export default StatusButton;
